import type { LiveEventFormData } from "../services/live-event-form/types";
import type { ILiveEventFormService } from "../services/live-event-form/types";

/**
 * Prevents non-numeric key input on numeric fields.
 * Allows digits, backspace, delete, arrow keys, and tab.
 */
export function numericKeydown(e: KeyboardEvent): void {
  if (
    !/[0-9]/.test(e.key) &&
    e.key !== "Backspace" &&
    e.key !== "Delete" &&
    e.key !== "ArrowLeft" &&
    e.key !== "ArrowRight" &&
    e.key !== "Tab"
  ) {
    e.preventDefault();
  }
}

/**
 * Creates a bound input handler that updates form data via the service.
 */
export function handleFormInput(service: ILiveEventFormService, field: keyof LiveEventFormData, event: Event): void {
  const target = event.target as HTMLInputElement | HTMLTextAreaElement;
  service.updateFormData(field, target.value);
}

/**
 * Creates a bound blur handler that validates a field via the service.
 */
export function handleFormBlur(service: ILiveEventFormService, field: keyof LiveEventFormData): void {
  service.validateFieldOnBlur(field);
}

/**
 * Returns today's date as YYYY-MM-DD string for date input min values.
 */
export function getTodayDate(): string {
  return new Date().toISOString().split("T")[0]!;
}
